// import React, { useContext, useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";

// const colors = [
//   "#0000FF", "#ff7687", "#f87171", "#fb923c", "#facc15", "#4ade80", "#34d399",
//   "#2dd4bf", "#38bdf8", "#60a5fa", "#818cf8", "#a78bfa", "#e879f9", "#f472b6",
//   "#f9a8d4", "#c084fc", "#fcd34d", "#86efac", "#5eead4", "#67e8f9"
// ];

// const LeadStatus = () => {
//   const { user } = useContext(AuthContext);
//   const [leadStatuses, setLeadStatuses] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showFields, setShowFields] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [form, setForm] = useState({ name: "", color: colors[0] });
//   const [editingStatus, setEditingStatus] = useState(null);
//   const [confirmDeleteId, setConfirmDeleteId] = useState(null);

//   const token = localStorage.getItem("token");
//   const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//   const handleToggleActive = async (statusId, currentActiveStatus) => {
//     try {
//       const newActiveStatus = !currentActiveStatus;
//       console.log("Toggling:", statusId, "from", currentActiveStatus, "to", newActiveStatus);
      
//       await axios.put(
//         `${API_URL}/api/leadStatus/update/active/${statusId}?active=${newActiveStatus}&companyId=${companyId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
      
//       // Optimistic update - immediately update UI
//       setLeadStatuses(prev => 
//         prev.map(status => 
//           status.leadStatusId === statusId 
//             ? { ...status, active: newActiveStatus }
//             : status
//         )
//       );
//     } catch (err) {
//       console.error("Toggle failed", err);
//       // Revert on error
//       fetchLeadStatuses();
//     }
//   };

//   const fetchLeadStatuses = useCallback(async () => {
//     try {
//       const res = await axios.get(`${API_URL}/api/leadStatus/company/${companyId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       console.log("Fetched statuses:", res.data);
      
//       setLeadStatuses(res.data);
//     } catch (err) {
//       console.error("Error fetching lead statuses", err);
//     }
//   }, [companyId, token]);

//   useEffect(() => {
//     fetchLeadStatuses();
//   }, [fetchLeadStatuses]);

//   const handleSave = async () => {
//     try {
//       if (editingStatus) {
//         await axios.put(
//           `${API_URL}/api/leadStatus/${editingStatus.leadStatusId}`,
//           { name: form.name, color: form.color },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       } else {
//         await axios.post(
//           `${API_URL}/api/leadStatus`,
//           { name: form.name, color: form.color, companyId },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       }
//       closeModal();
//       fetchLeadStatuses();
//     } catch (err) {
//       console.error("Save failed", err);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`${API_URL}/api/leadStatus/${confirmDeleteId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setConfirmDeleteId(null);
//       fetchLeadStatuses();
//     } catch (err) {
//       console.error("Delete failed", err);
//     }
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setForm({ name: "", color: colors[0] });
//     setEditingStatus(null);
//   };

//   return (
//     <div className="p-2 bg-gray-100 shadow-lg dark:bg-gray-900 dark:text-white">
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-xl font-bold">Lead Status</h2>
//         <div className="flex gap-2">
//           <button
//             onClick={() => setShowModal(true)}
//             className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
//           >
//             <FaPlus /> Add
//           </button>
//           <button
//             onClick={() => setShowFields(!showFields)}
//             className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
//           >
//             <FaSearch /> {showFields ? "Close" : "Search"}
//           </button>
//         </div>
//       </div>

//       {showFields && (
//         <div className="mb-4 flex flex-wrap gap-2 items-center">
//           <input
//             type="text"
//             placeholder="Search lead status..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="border px-3 py-2 rounded w-full md:w-1/3 dark:bg-gray-800 dark:text-white"
//           />
//           <button
//             onClick={async () => {
//               try {
//                 const res = await axios.get(
//                   `${API_URL}/api/leadStatus/company/${companyId}`,
//                   { headers: { Authorization: `Bearer ${token}` } }
//                 );
//                 const filtered = res.data.filter((status) =>
//                   status.name.toLowerCase().includes(searchTerm.toLowerCase())
//                 );
//                 setLeadStatuses(filtered);
//               } catch (err) {
//                 console.error("Search failed", err);
//               }
//             }}
//             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//           >
//             Search
//           </button>
//           <button
//             onClick={() => {
//               setSearchTerm("");
//               fetchLeadStatuses();
//             }}
//             className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
//           >
//             Clear
//           </button>
//         </div>
//       )}

//       <div className="overflow-x-auto">
//         <table className="w-full border">
//           <thead className="bg-gray-50 dark:bg-gray-800 dark:text-white">
//             <tr>
//               <th className="px-4 py-2 text-left">Status</th>
//               <th className="px-4 py-2 text-left">Active Status</th>
//               <th className="px-4 py-2 text-left">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {leadStatuses.map((status) => (
//               <tr key={status.leadStatusId} className="border-t">
//                 <td className="px-4 py-2">
//                   <span
//                     className="inline-block px-3 py-1 rounded-full text-white"
//                     style={{ backgroundColor: status.color || "#6b7280" }}
//                   >
//                     {status.name}
//                   </span>
//                 </td>
//                 <td className="px-4 py-2">
//                   {/* Professional Toggle Switch - FIXED: using status.active */}
//                   <div className="flex items-center">
//                     <button
//                       onClick={() => handleToggleActive(status.leadStatusId, status.active)}
//                       className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
//                         status.active ? 'bg-green-500' : 'bg-gray-300'
//                       }`}
//                     >
//                       <span
//                         className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
//                           status.active ? 'translate-x-6' : 'translate-x-1'
//                         }`}
//                       />
//                     </button>
//                     <span className={`ml-2 text-sm font-medium ${status.active ? 'text-green-600' : 'text-gray-500'}`}>
//                       {status.active ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                 </td>
//                 <td className="px-4 py-2 flex gap-4">
//                   <button
//                     onClick={() => {
//                       setForm({ name: status.name, color: status.color });
//                       setEditingStatus(status);
//                       setShowModal(true);
//                     }}
//                     className="text-yellow-500 hover:text-yellow-700 transition-colors"
//                     title="Edit"
//                   >
//                     <FaEdit />
//                   </button>
//                   <button
//                     onClick={() => setConfirmDeleteId(status.leadStatusId)}
//                     className="text-red-600 hover:text-red-800 transition-colors"
//                     title="Delete"
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Create/Edit Modal */}
//       {showModal && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
//           <div className="bg-white rounded-lg p-6 w-full max-w-md dark:bg-gray-800 dark:text-white">
//             <h2 className="text-xl font-bold mb-4">{editingStatus ? "Edit" : "Create"} Lead Status</h2>
//             <input
//               type="text"
//               value={form.name}
//               onChange={(e) => setForm({ ...form, name: e.target.value })}
//               className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-800 dark:text-white"
//               placeholder="Status Name"
//             />
//             <div className="flex flex-wrap gap-2 mb-4">
//               {colors.map((color) => (
//                 <span
//                   key={color}
//                   onClick={() => setForm({ ...form, color })}
//                   className={`w-6 h-6 rounded-full cursor-pointer border-2 ${form.color === color ? "border-black" : "border-white"}`}
//                   style={{ backgroundColor: color }}
//                 />
//               ))}
//             </div>
//             <div className="flex justify-end gap-2">
//               <button onClick={closeModal} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:bg-gray-500">Cancel</button>
//               <button onClick={handleSave} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
//                 {editingStatus ? "Update" : "Create"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirm Delete Modal */}
//       {confirmDeleteId && (
//          <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
//           <div className="bg-white rounded-lg p-6 w-full max-w-sm">
//             <h2 className="text-lg font-bold mb-4">Are you sure you want to delete this status?</h2>
//             <div className="flex justify-end gap-2">
//               <button onClick={() => setConfirmDeleteId(null)} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancel</button>
//               <button onClick={handleDelete} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">Delete</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeadStatus;






import React, { useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";

const colors = [
  "#0000FF", "#ff7687", "#f87171", "#fb923c", "#facc15", "#4ade80", "#34d399",
  "#2dd4bf", "#38bdf8", "#60a5fa", "#818cf8", "#a78bfa", "#e879f9", "#f472b6",
  "#f9a8d4", "#c084fc", "#fcd34d", "#86efac", "#5eead4", "#67e8f9"
];

const LeadStatus = () => {
  const { user } = useContext(AuthContext);
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFields, setShowFields] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: "", color: colors[0] });
  const [editingStatus, setEditingStatus] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  const token = localStorage.getItem("token");
  const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

  const handleToggleActive = async (statusId, currentActiveStatus) => {
    try {
      const newActiveStatus = !currentActiveStatus;
      console.log("Toggling:", statusId, "from", currentActiveStatus, "to", newActiveStatus);
      
      await axios.put(
        `${API_URL}/api/leadStatus/update/active/${statusId}?active=${newActiveStatus}&companyId=${companyId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Optimistic update - immediately update UI
      setLeadStatuses(prev => 
        prev.map(status => 
          status.leadStatusId === statusId 
            ? { ...status, active: newActiveStatus }
            : status
        )
      );
    } catch (err) {
      console.error("Toggle failed", err);
      // Revert on error
      fetchLeadStatuses();
    }
  };

  const fetchLeadStatuses = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/leadStatus/company/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Fetched statuses:", res.data);
      
      setLeadStatuses(res.data);
    } catch (err) {
      console.error("Error fetching lead statuses", err);
    }
  }, [companyId, token]);

  useEffect(() => {
    fetchLeadStatuses();
  }, [fetchLeadStatuses]);

  const handleSave = async () => {
    try {
      if (editingStatus) {
        await axios.put(
          `${API_URL}/api/leadStatus/${editingStatus.leadStatusId}`,
          { name: form.name, color: form.color },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${API_URL}/api/leadStatus`,
          { name: form.name, color: form.color, companyId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      closeModal();
      fetchLeadStatuses();
    } catch (err) {
      console.error("Save failed", err);
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_URL}/api/leadStatus/${confirmDeleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConfirmDeleteId(null);
      fetchLeadStatuses();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setForm({ name: "", color: colors[0] });
    setEditingStatus(null);
  };

  return (
    <div className="p-2 bg-[#FAF8FF] shadow-lg cfg-font dark:bg-gray-900 dark:text-white">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
            <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold cfg-heading">Lead Status</h2>
        <div className="flex gap-2">
          <button
            onClick={() => setShowModal(true)}
            className="px-2 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2"
          >
            <FaPlus /> Add
          </button>
          <button
            onClick={() => setShowFields(!showFields)}
            className="px-2 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2"
          >
            <FaSearch /> {showFields ? "Close" : "Search"}
          </button>
        </div>
      </div>

      {showFields && (
        <div className="mb-4 flex flex-wrap gap-2 items-center">
          <input
            type="text"
            placeholder="Search lead status..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-[#E5E7EB] px-3 py-2 rounded w-full md:w-1/3 dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
          />
          <button
            onClick={async () => {
              try {
                const res = await axios.get(
                  `${API_URL}/api/leadStatus/company/${companyId}`,
                  { headers: { Authorization: `Bearer ${token}` } }
                );
                const filtered = res.data.filter((status) =>
                  status.name.toLowerCase().includes(searchTerm.toLowerCase())
                );
                setLeadStatuses(filtered);
              } catch (err) {
                console.error("Search failed", err);
              }
            }}
            className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
          >
            Search
          </button>
          <button
            onClick={() => {
              setSearchTerm("");
              fetchLeadStatuses();
            }}
            className="bg-[#F3F4F6] text-[#374151] px-4 py-2 rounded hover:bg-[#E5E7EB]"
          >
            Clear
          </button>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full border border-[#E5E7EB] rounded-lg overflow-hidden">
          <thead className="bg-[#F3F4F6] dark:bg-gray-800 dark:text-white">
            <tr>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-left">Active Status</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {leadStatuses.map((status) => (
              <tr key={status.leadStatusId} className="border-t">
                <td className="px-4 py-2">
                  <span
                    className="inline-block px-3 py-1 rounded-full text-white"
                    style={{ backgroundColor: status.color || "#6b7280" }}
                  >
                    {status.name}
                  </span>
                </td>
                <td className="px-4 py-2">
                  {/* Professional Toggle Switch - FIXED: using status.active */}
                  <div className="flex items-center">
                    <button
                      onClick={() => handleToggleActive(status.leadStatusId, status.active)}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                        status.active ? 'bg-green-500' : 'bg-gray-300'
                      }`}
                    >
                      <span
                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                          status.active ? 'translate-x-6' : 'translate-x-1'
                        }`}
                      />
                    </button>
                    <span className={`ml-2 text-sm font-medium ${status.active ? 'text-green-600' : 'text-gray-500'}`}>
                      {status.active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-2 flex gap-4">
                  <button
                    onClick={() => {
                      setForm({ name: status.name, color: status.color });
                      setEditingStatus(status);
                      setShowModal(true);
                    }}
                    className="text-[#8B5CF6] hover:text-[#673AB7] transition-colors"
                    title="Edit"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => setConfirmDeleteId(status.leadStatusId)}
                    className="text-[#EF4444] hover:text-[#B91C1C] transition-colors"
                    title="Delete"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Create/Edit Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-xl p-6 w-full max-w-md dark:bg-gray-800 dark:text-white shadow-xl">
            <h2 className="text-xl font-bold mb-4 cfg-heading">{editingStatus ? "Edit" : "Create"} Lead Status</h2>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full border border-[#E5E7EB] px-3 py-2 mb-4 rounded dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              placeholder="Status Name"
            />
            <div className="flex flex-wrap gap-2 mb-4">
              {colors.map((color) => (
                <span
                  key={color}
                  onClick={() => setForm({ ...form, color })}
                  className={`w-6 h-6 rounded-full cursor-pointer border-2 ${form.color === color ? "border-black" : "border-white"}`}
                  style={{ backgroundColor: color }}
                />
              ))}
            </div>
            <div className="flex justify-end gap-2">
              <button onClick={closeModal} className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB] dark:bg-gray-500">Cancel</button>
              <button onClick={handleSave} className="px-4 py-2 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6]">
                {editingStatus ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {confirmDeleteId && (
         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-xl">
            <h2 className="text-lg font-bold mb-4 cfg-heading">Are you sure you want to delete this status?</h2>
            <div className="flex justify-end gap-2">
              <button onClick={() => setConfirmDeleteId(null)} className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB]">Cancel</button>
              <button onClick={handleDelete} className="px-4 py-2 bg-[#EF4444] text-white rounded hover:bg-[#B91C1C]">Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadStatus;